import { Component, OnInit } from '@angular/core';
import { ApiIntegration } from '../../_services/api.integration';
import { AlertService } from '../../_services/alert.service';

@Component({
  selector: 'app-shipment-exception-reports',
  templateUrl: './shipment-exception-reports.component.html',
  styleUrls: ['./shipment-exception-reports.component.scss'],
})
export class ShipmentExceptionReportsComponent implements OnInit {

  orderListLength: any;
  startDate: any;
  endDate: any;
  startDateError: any;
  endDateError: any;
  carrierName: any;
  accountOwner: any;
  accountOwners: any={};
  orderList: any={};
  carrierList: any={};

  constructor( private alertService: AlertService,private api: ApiIntegration) {
    this.api.getAccountOwners("1", "ACTIVE").subscribe((data: any) => {
      this.accountOwners = data.getAccountOwnersResponses;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  ngOnInit() {}

  customSearchAccountOwner(term: string, item: any = []) {
    term = term.toLowerCase();
    return item.ownerName.toLowerCase().indexOf(term) > -1 || (item.companyName && item.companyName.toLowerCase().indexOf(term) > -1);
  }
  exportToXLSX(){}

  exportToPdf(){}

  generateReport(){}

  clearFields(){}

}
